import {Component, OnInit, OnDestroy} from '@angular/core';
import {combineLatest, forkJoin} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {finalize, map, tap} from 'rxjs/operators';
import { AddObjectComponent } from '../add-object/add-object.component';
import { FgjsService, ILivingComplex, ILivingComplexUser, IObject, IUser } from '../fgjs.service';
import { AddObjectsComponent } from '../../components/add-objects/add-objects.component';

@Component({
  selector: 'app-users-fgjs-list',
  templateUrl: './users-fgjs-list.component.html',
  styleUrl: './users-fgjs-list.component.scss'
})
export class UsersFgjsListComponent implements OnInit, OnDestroy{
  displayedColumns = ['id', 'fullName', 'email', 'usersRoles', 'objectName', 'option'];
  users: MatTableDataSource<IUser>;
  mainUsers: IUser[] = [];
  loading = false;
  combined = null;
  selectedUserType = false;
  buildings: ILivingComplex[] = [];
  selectedComplex: ILivingComplex | null = null;
  buildings2: ILivingComplex[] = [];
  users1: ILivingComplexUser[] = [];
  users2: IUser[] = [];

  selectedComplexes: ILivingComplex[] = [];

  constructor(
    public dialog: MatDialog,
    private serviceFgjs: FgjsService) {
  }

  ngOnInit() {
    this.loadList();
  }

  ngOnDestroy() {
    this.combined.unsubscribe();
  }

  loadList() {
    this.loading = true;
    this.combined = combineLatest([
      this.serviceFgjs.getUsers()
    ])
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(res => {
        this.mainUsers = res[0];
        this.serviceFgjs.saveUsers.emit(this.mainUsers);
        this.selectUserType();
        this.selectComplexUser();
      });
  }

  selectUserType() {
    this.users = new MatTableDataSource(this.mainUsers.filter(f => f.roles.includes('EC_Curator')));
    this.users2 = this.mainUsers.filter(f => f.roles.includes('EC_Curator'));
  }

  selectComplexUser() {
    const observables = this.users.filteredData.map(f =>
      this.serviceFgjs.getComplexUser(f.userID)
    );

    forkJoin(observables).pipe(
      map(results => results.reduce((acc, curr) => acc.concat(curr), []))
    ).subscribe(res => {
      this.users1 = res;
      this.users1.forEach(f => {
        const user = this.users2.find(u => u.userID === f.userID);
        if (user) {
          this.updateUser(f.userID, f.livingComplexID);
        }
      })
    });
  }

  applyFilter(event: Event) {
    this.users.filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  }

  openDialogObjects(lastName: string, firstName: string, middleName: string, id: number, email: string) {
    const dialogRef = this.dialog.open(AddObjectsComponent, {
        height: '90%',
        width: '90%',
        data: {
          name: lastName+' '+firstName+' '+middleName,
          id: id,
          email: email,
          anchoredLvComplex: this.users1
          //complex: this.buildings
        }
      });

    dialogRef.componentInstance.complexesSelected.subscribe((complex: ILivingComplex[]) => {
      this.selectedComplexes = complex;
      this.updateComplexesUser(id);
      this.loadList();
    });
  }

  updateComplexesUser(id: number) {
    this.selectedComplexes.forEach(r => {
      this.serviceFgjs.addComplexUser(id, r.id)
    })
  }

  openDialog(lastName: string, firstName: string, middleName: string, id: number, email: string) {
    const dialogRef = this.dialog.open(AddObjectComponent, {
      height: '90%',
      width: '90%',
      data: {
        name: lastName+' '+firstName+' '+middleName,
        id: id,
        email: email,
        complex: this.buildings,
        anchoredLvComplex: this.users1
      }
    });

    dialogRef.componentInstance.complexSelected.subscribe((complex: ILivingComplex) => {
      this.selectedComplex = complex;
      // this.serviceFgjs.deleteComplexUser(id);
      // this.serviceFgjs.addComplexUser(id, this.selectedComplex.id);
      this.updateComplexUser(id, this.selectedComplex.id);
      this.loadList();
    });
  }

  updateUser(id: number, complexId: number){
    const user = this.users2.find(u => u.userID === id);
    const complex = this.users1.find(c => c.livingComplexID === complexId);
    if (user && complex) {
      user.livingComplexes = complex.livingComplexTitle;
      this.mainUsers.push(user);
    }
  }

  updateComplexUser(id: number, complexId: number) {
    this.serviceFgjs.deleteComplexUser(id)
      .then(response => {
        if (response.status === 200) {
          console.log(response.status);
          return this.serviceFgjs.addComplexUser(id, complexId);
        } else {
          throw new Error('Error');
        }
      })
      .then(result => {
        //console.log(result);
      })
      .catch(error => {
        //console.error(error);
      });
  }

  truncateText(text: string | null | undefined): string {
    if (!text) {
      return '';
    }

    if (text.length <= 50) {
      return text;
    }
    return text.slice(0, 50) + '...';
  }
}
